import { render } from "./azurestorage.vue?vue&type=template&id=0d460acc"
import script from "./azurestorage.vue?vue&type=script&lang=js"
export * from "./azurestorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__